export default class Enum {
  constructor(value, desc) {
    this.value = value;
    this.desc = desc;
  }

  toString() {
    return this.value;
  }

  toJSON() {
    return this.value;
  }

  /**
   * 引数が当Enumと一致するかどうかチェック（Proxyが渡されることを想定）
   *
   * @param target
   * @returns {boolean}
   */
  is(target) {
    return this.value === target?.value;
  }

  /**
   * 引数のいずれかが当Enumと一致するかどうかチェック
   *
   * @param targets
   * @returns {*}
   */
  any(targets) {
    return targets.some(target => this.is(target));
  }

  /**
   * 引数が当Enumと一致しないかどうかチェック
   *
   * @param target
   * @returns {boolean}
   */
  not(target) {
    return !this.is(target);
  }

  get description() {
    return this.desc;
  }

  /**
   * 指定した名前のEnumを返す
   *
   * @returns {null}
   * @param value
   */
  static of(value) {
    if (value != null) {
      if (value instanceof Enum) {
        value = value.value;
      }
      for (const enu of this.values()) {
        if (enu.value === value) {
          return enu;
        }
      }
    }
  }

  /**
   * 指定した名前のEnumを返す（配列用）
   *
   * @param {Array} values - 配列
   * @returns {Array} - 配列内の値に対応するEnumの配列
   */
  static ofArray(values) {
    if (Array.isArray(values)) {
      return values.map(value => this.of(value)).filter(enu => enu !== null);
    }
    return [];
  }

  /**
   * 項目の一覧を返す
   *
   * @returns {(* | Enum | (function(): *))[]}
   */
  static values() {
    return Object.values(this).filter(v => v instanceof Enum);
  }
}
